/* eslint-disable no-unused-vars */
import { yupResolver } from "@hookform/resolvers/yup";
import PropTypes from "prop-types";
import React, { useEffect, useRef, useState } from "react";
import { Button, Modal } from "react-bootstrap";
import { Controller, useForm } from "react-hook-form";
import { toast } from "react-hot-toast";
import { useDispatch } from "react-redux";
import Select from "react-select";
import * as yup from "yup";
import { commissionType, feeCategory } from "../../utils/helpers/objectHelpers";
import { RemittanceService } from "../../utils/services/remittance.service";

function AddNewPaymentMethod({ dictionary, show, handleClose, corridor }) {
  const formRef = useRef();
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(false);

  const schema = yup
    .object({
      chargeCategory: yup
        .object()
        .shape({
          label: yup.string(),
          value: yup.string(),
        })
        .required(),
      corridor: yup
        .object()
        .shape({
          label: yup.string(),
          value: yup.string(),
        })
        .required(),
      bottomAmount: yup.number().required(),
      topAmount: yup.number().required(),
      fee: yup.number().required(),
      rateType: yup
        .object()
        .shape({
          label: yup.string(),
          value: yup.string(),
        })
        .required(),
    })
    .required();
  const {
    register,
    handleSubmit,
    formState: { errors },
    control,
    reset,
    setValue,
  } = useForm({
    resolver: yupResolver(schema),
  });

  const onSubmit = async (data) => {
    setLoading(true);
    const payload = {
      bottomAmount: data?.bottomAmount,
      topAmount: data?.topAmount,
      fee: data?.fee,
      rateType: data?.rateType?.value,
      superChargeCategory: "PAYMENT_METHODS",
      chargeCategory: data?.chargeCategory?.value,
      inclusive: false,
      corridorId: data?.corridor?.value,
    };
    try {
      const response = await RemittanceService.addBandRate(payload);
      if (response.data.status === "SUCCESS") {
        reset({
          chargeCategory: { label: "", value: "" },
          corridor: { label: "", value: "" },
          bottomAmount: 0,
          topAmount: 0,
          fee: 0,
          rateType: { label: "", value: "" },
        });
        toast.success("payment method set up successful");
        handleClose();
        setLoading(false);
      }
    } catch (error) {
      setLoading(false);
      return error;
    }
    setLoading(false);
  };

  const corridorData =
    corridor &&
    corridor?.map((i) => {
      return {
        label: `${i.tradeOriginatingCountry}>>${i.destinationCountry}>>${i.deliveryMethod}`,
        value: i.id,
      };
    });

  return (
    <Modal
      show={show}
      backdrop="static"
      keyboard={false}
      size={"lg"}
      onHide={handleClose}
    >
      <Modal.Header closeButton onHide={handleClose}>
        <Modal.Title className="fw-bold">
          {dictionary
            ? dictionary["para_create_new_charge_for_paymentmethod"]
            : "Create new fee for Payment Method"}
        </Modal.Title>
      </Modal.Header>
      <form
        className="needs-validation"
        onSubmit={handleSubmit(onSubmit)}
        ref={formRef}
      >
        <Modal.Body>
          <div className="form-row">
            <div className="col-md-6 col-lg-6 mb-3">
              <label>
                {dictionary
                  ? dictionary["para_payment_method"]
                  : "Payment Method"}
              </label>
              <Controller
                name="chargeCategory"
                control={control}
                rules={{
                  required: true,
                }}
                render={({ field }) => {
                  return (
                    <Select
                      {...field}
                      options={feeCategory()}
                      isClearable={false}
                      isSearchable={true}
                      maxMenuHeight={250}
                      menuPlacement="bottom"
                    />
                  );
                }}
              />
            </div>

            <div className="col-md-6 col-lg-6 mb-3">
              <label>
                {dictionary ? dictionary["WO_CORRIDOR_166705112"] : "Corridors"}
              </label>
              <Controller
                name="corridor"
                control={control}
                rules={{
                  required: true,
                }}
                render={({ field }) => {
                  return (
                    <Select
                      {...field}
                      options={corridorData}
                      isClearable={false}
                      isSearchable={true}
                      maxMenuHeight={250}
                      menuPlacement="bottom"
                    />
                  );
                }}
              />
            </div>

            <div className="col-md-6 col-lg-6 mb-3">
              <label>
                {dictionary
                  ? dictionary["para_starting_amount"]
                  : "Starting Amount"}
              </label>
              <input
                type={"number"}
                className="form-control border px-3"
                name="bottomAmount"
                {...register("bottomAmount", {
                  required: {
                    value: true,
                    message: "This field is required",
                  },
                })}
              />
            </div>

            <div className="col-md-6 col-lg-6 mb-3">
              <label>
                {dictionary ? dictionary["para_end_amount"] : "End Amount"}
              </label>
              <input
                type={"number"}
                className="form-control border px-3"
                name="topAmount"
                {...register("topAmount", {
                  required: {
                    value: true,
                    message: "This field is required",
                  },
                })}
              />
            </div>

            <div className="col-md-6 col-lg-6 mb-3">
              <label>
                {dictionary ? dictionary["m_set_remittance_commission"] : "Fee"}
              </label>
              <input
                type={"number"}
                className="form-control border px-3"
                name="fee"
                {...register("fee", {
                  required: {
                    value: true,
                    message: "This field is required",
                  },
                })}
              />
            </div>

            <div className="col-md-6 col-lg-6 mb-3">
              <label>
                {dictionary ? dictionary["para_charge_type"] : "Fee Type"}
              </label>
              <Controller
                name="rateType"
                control={control}
                rules={{
                  required: true,
                }}
                render={({ field }) => {
                  return (
                    <Select
                      {...field}
                      options={commissionType}
                      isClearable={false}
                      isSearchable={true}
                      maxMenuHeight={250}
                      menuPlacement="bottom"
                    />
                  );
                }}
              />
            </div>
          </div>
        </Modal.Body>

        <Modal.Footer>
          <Button variant="secondary" onClick={handleClose}>
            Close
          </Button>
          <Button
            variant="secondary"
            className="text-uppercase"
            type={"submit"}
          >
            {dictionary ? dictionary["button_save_charges"] : "SAVE FEE"}
            &nbsp;&nbsp;
            {loading && <i className="fa fa-spinner fa-spin" />}
          </Button>
        </Modal.Footer>
      </form>
    </Modal>
  );
}

export default AddNewPaymentMethod;

AddNewPaymentMethod.defaultProps = {
  handleClose: () => {},
};

AddNewPaymentMethod.propTypes = {
  show: PropTypes.bool.isRequired,
  handleClose: PropTypes.func.isRequired,
};
